'use client';

import { useDraggable } from '@dnd-kit/core';
import { ReactNode, CSSProperties } from 'react';
import { cn } from '@/lib/utils';

interface DraggableItemProps {
  id: string;
  children: ReactNode;
  index: number;
  data?: Record<string, unknown>;
}

export function DraggableItem({ id, children, index, data }: DraggableItemProps) {
  const { attributes, listeners, setNodeRef, isDragging } = useDraggable({
    id,
    data: { ...data, index },
  });

  const style: CSSProperties = {
    // When dragging, fade out the original (DragOverlay shows the copy)
    opacity: isDragging ? 0.4 : 1,
    transform: isDragging ? 'scale(0.98)' : undefined,
    transition: 'opacity 150ms ease, transform 150ms ease',
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className={cn(
        "touch-none select-none",
        !isDragging && "cursor-grab active:cursor-grabbing",
        isDragging && "pointer-events-none"
      )}
      {...listeners}
      {...attributes}
    >
      {children}
    </div>
  );
}
